import { render, staticRenderFns } from "./home.html?vue&type=template&id=39f87be5&scoped=true&"
import script from "./home.js?vue&type=script&lang=js&"
export * from "./home.js?vue&type=script&lang=js&"
import style0 from "./home.less?vue&type=style&index=0&id=39f87be5&lang=less&scoped=true&"
import style1 from "./otherStyle.less?vue&type=style&index=1&lang=less&"
import style2 from "./mobile.less?vue&type=style&index=2&id=39f87be5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f87be5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39f87be5')) {
      api.createRecord('39f87be5', component.options)
    } else {
      api.reload('39f87be5', component.options)
    }
    module.hot.accept("./home.html?vue&type=template&id=39f87be5&scoped=true&", function () {
      api.rerender('39f87be5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/home.vue"
export default component.exports